import React, { Component } from 'react'
import styled, { withTheme } from 'styled-components'
import PropTypes from 'prop-types'
import Col from '../utils/StyledCol'
import Row from '../utils/StyledRow'
import { SIZES } from '../../constants'
import WidgetContainer from '../containers/WidgetContainer'

const Iframe = styled.iframe`
  border: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;

  @media (max-width: 480px) {
    min-height: 310px;
  }

  @media (min-width: 481px) and (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    min-height: 180px;
  }

  @media (min-width: ${SIZES.BREAKPOINT_MD}px) and (max-width: 1123px) {
    min-height: 300px;
  }

  @media (min-width: 1124px) {
    min-height: 190px;
  }
`

class FlightTickets extends Component {
  constructor (props) {
    super(props)

    this.handleIframeMessage = this.handleIframeMessage.bind(this)
  }
  componentDidMount () {
    window.addEventListener('message', this.handleIframeMessage, false)
  }

  componentWillUnmount () {
    window.removeEventListener('message', this.handleIframeMessage, false)
  }

  handleIframeMessage ({ data, source, origin }) {
    const {
      theme: {
        flightTickets: theme
      },
      widget: {
        utmMedium,
        utmSource
      }
    } = this.props

    if (data === 'tmn.get-config' && source) {
      source.postMessage({
        'tmn.type': 'config',
        utm: {
          UI: 'centrum',
          utm_source: utmSource,
          utm_medium: utmMedium
        },
        theme
      }, origin)
    }
  }

  render () {
    const {
      widget,
      widget: {
        meta: {
          iframeUrl
        }
      }
    } = this.props

    return (
      <WidgetContainer widget={widget}>
        <Row>
          <Col>
            <Iframe src={iframeUrl} className='searchFrame' name='letenkyBox'/>
          </Col>
        </Row>
      </WidgetContainer>
    )
  }
}

FlightTickets.propTypes = {
  widget: PropTypes.object.isRequired
}

export default withTheme(FlightTickets)
